import React from 'react';
import { DatePicker, Form } from 'antd';

function TextInput({
  name, label, errorMessage, disabled = false, rules = [],
}) {
  return (
    <Form.Item
      label={label}
      name={name}
      validateStatus={errorMessage && 'error'}
      help={errorMessage}
      rules={rules}
      className="w-full"
    >
      <DatePicker className="w-full" disabled={disabled} />
    </Form.Item>
  );
}

export default TextInput;
